import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  permissions: {}, // email -> { email, reports }
  mailRoutes: {},
  loaded: false,
  loading: false,
}

const accessControlSlice = createSlice({
  name: 'accessControl',
  initialState,
  reducers: {
    accessControlLoadStart: (state) => {
      state.loading = true
    },
    accessControlLoaded: (state, { payload }) => {
      state.permissions = payload?.permissions || {}
      state.mailRoutes = payload?.mailRoutes || {}
      state.loaded = true
      state.loading = false
    },
    accessControlLoadFail: (state) => {
      state.loading = false
    },
    setPermissionLocal: (state, { payload }) => {
      const email = String(payload?.email || '').toLowerCase()
      if (!email) return
      state.permissions[email] = {
        email,
        reports: payload.reports,
        updatedAt: payload.updatedAt,
        updatedBy: payload.updatedBy,
      }
    },
    setMailRoutesLocal: (state, { payload }) => {
      state.mailRoutes = payload || {}
    },
    clearAccessControl: () => initialState,
  },
})

export const {
  accessControlLoadStart,
  accessControlLoaded,
  accessControlLoadFail,
  setPermissionLocal,
  setMailRoutesLocal,
  clearAccessControl,
} = accessControlSlice.actions

export default accessControlSlice.reducer
